import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, getQueryKey } from '@feature/utils';

import * as api from './LegalHolidayApi';
import { LegalHoliday, LegalHolidayRequest } from './LegalHolidayTypes';

const legalHolidayKey = getQueryKey('legalHoliday');

export function getLegalHolidayListOptions(year?: number): UseSuspenseQueryOptions<LegalHoliday[]> {
  return {
    queryKey: legalHolidayKey.as(['list', year ?? null]),
    queryFn: () => api.list(year),
  };
}

export function useLegalHolidayCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: LegalHolidayRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: legalHolidayKey.root(),
      }),
  });
}

export function useLegalHolidayUpdate(legalHolidayId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: LegalHolidayRequest) => api.update(legalHolidayId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: legalHolidayKey.root(),
      }),
  });
}

export function useLegalHolidayDelete(legalHolidayId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(legalHolidayId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: legalHolidayKey.root(),
      }),
  });
}
